import React, { Suspense } from 'react';
import { useLocation } from 'react-router-dom';

import LoadingScreen from '../../components/LoadingScreen';

const PayoutsListComponent = React.lazy(() => import('./components/PayoutsList'));

const PayoutsList = () => {
  const { pathname } = useLocation();
  return (
    <div>
      <Suspense fallback={<LoadingScreen isDashboard={pathname.includes('/dashboard')} />}>
        <PayoutsListComponent />
      </Suspense>
    </div>
  );
};

export default PayoutsList;
